import React from 'react';

interface IconCloseProps {
    iconClasses?: string;
    width?: number | string;
    height?: number | string;
}

const IconClose: React.FC<IconCloseProps> = ({ iconClasses, width = 12, height = 12 }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon icon-close ${iconClasses ?? ''}`}
        >
            <path
                d="M11.6073 0.292898C11.9977 0.683437 11.9978 1.31665 11.6073 1.70711L7.36539 5.94906L11.6087 10.1924C11.999 10.5829 11.9992 11.2161 11.6087 11.6066C11.2183 11.997 10.585 11.9969 10.1945 11.6066L5.95117 7.36327L1.70784 11.6066C1.31736 11.9969 0.684099 11.9969 0.293627 11.6066C-0.0968296 11.2161 -0.0966951 10.5829 0.293627 10.1924L4.53696 5.94906L0.295008 1.70711C-0.0955025 1.3166 -0.0954756 0.683425 0.295008 0.292898C0.685533 -0.0976266 1.3187 -0.0976267 1.70922 0.292898L5.95117 4.53485L10.1931 0.292898C10.5836 -0.0976267 11.2168 -0.0976266 11.6073 0.292898Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default IconClose;
